import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { FaInstagram, FaFacebook, FaTiktok } from "react-icons/fa6";
import { SOCIAL_LINKS } from "../lib/contact";

const COLUMNS = [
    {
        title: "BUILDEASE",
        links: [
            { label: "Home", href: "/" },
            { label: "About", href: "/about" },
            { label: "Our Vision", href: "/about#vision-section" },
            { label: "How It Works", href: "/how-it-works" },
            { label: "Building Sectors", href: "/sectors" },
        ],
    },
    {
        title: "PLATFORM",
        links: [
            { label: "Plan Intelligence", href: "/product#exploration" },
            { label: "BOQ & Cost Intelligence", href: "/sample-report" },
            { label: "Quote Analysis", href: "/product#quote-analyzer" },
            { label: "Home Vision", href: "/home-vision" },
            { label: "Materials Intelligence", href: "/materials-intelligence" },
        ],
    },
    {
        title: "RESOURCES",
        links: [
            { label: "BuildEase Insights", href: "/insights" },
            { label: "FAQs", href: "/faqs" },
            { label: "Sample Report", href: "/sample-report" },
            { label: "Trust & Transparency", href: "/trust" },
        ],
    },
    {
        title: "SUPPORT",
        links: [
            { label: "Contact", href: "/#contact" },
            { label: "Privacy Policy", href: "/privacy" },
            { label: "Terms & Conditions", href: "/terms" },
            {
                label: "support@buildease.co.za",
                href: "mailto:support@buildease.co.za?subject=BuildEase%20Support%20Request",
                external: true,
            },
        ],
    },
];

const SOCIAL_ICONS = {
    Instagram: FaInstagram,
    Facebook: FaFacebook,
    TikTok: FaTiktok,
};

const Footer = () => (
    <footer className="relative border-t border-white/10 bg-ink">
        <div className="mx-auto max-w-[1600px] px-6 py-16 md:px-10 lg:px-16 lg:py-20">
            <div className="grid gap-12 lg:grid-cols-12">
                <div className="lg:col-span-4">
                    <Logo className="h-[54px] w-auto md:h-[64px]" />
                    <p className="mt-6 max-w-xs text-[15px] leading-relaxed text-mist">
                        Construction intelligence for homeowners.
                    </p>
                    <div className="mt-8 flex items-center gap-3">
                        {SOCIAL_LINKS.map((s) => {
                            const Icon = SOCIAL_ICONS[s.label];
                            return (
                                <a
                                    key={s.label}
                                    href={s.url}
                                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                                    aria-label={`Follow BuildEase on ${s.label}`}
                                    className="inline-flex h-10 w-10 items-center justify-center border border-white/15 text-mist transition-colors duration-300 hover:border-accent hover:text-accent"
                                >
                                    <Icon className="h-4 w-4" />
                                </a>
                            );
                        })}
                    </div>
                </div>

                <nav
                    aria-label="Footer"
                    className="grid grid-cols-2 gap-10 sm:grid-cols-4 lg:col-span-8"
                >
                    {COLUMNS.map((col) => (
                        <div key={col.title}>
                            <p className="font-mono text-[13px] tracking-[0.3em] text-cad">
                                {col.title}
                            </p>
                            <ul className="mt-5 space-y-3">
                                {col.links.map((l) => (
                                    <li key={l.label}>
                                        {l.external ? (
                                            <a
                                                href={l.href}
                                                data-testid={`footer-link-${l.label
                                                    .toLowerCase()
                                                    .replace(/[^a-z0-9]+/g, "-")}`}
                                                className="break-all text-[14px] text-mist transition-colors duration-300 hover:text-accent"
                                            >
                                                {l.label}
                                            </a>
                                        ) : (
                                            <Link
                                                to={l.href}
                                                data-testid={`footer-link-${l.label
                                                    .toLowerCase()
                                                    .replace(/[^a-z0-9]+/g, "-")}`}
                                                className="break-all text-[14px] text-mist transition-colors duration-300 hover:text-accent"
                                            >
                                                {l.label}
                                            </Link>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </nav>
            </div>

            <p
                data-testid="footer-imagery-note"
                className="mt-16 max-w-2xl font-mono text-[13px] leading-relaxed tracking-[0.18em] text-cad"
            >
                IMAGERY ON THIS SITE IS FOR ILLUSTRATION ONLY AND DOES NOT
                DEPICT ACTUAL BUILDEASE PROJECTS OR OUTPUTS.
            </p>

            <div className="mt-8 flex flex-col gap-6 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
                <p
                    data-testid="footer-closing-line"
                    className="font-mono text-[13px] tracking-[0.3em] text-mist"
                >
                    BUILDEASE — SIMPLIFY. BUILD. LIVE.
                </p>
                <p className="font-mono text-[13px] tracking-[0.18em] text-cad">
                    SOUTH AFRICA · RESIDENTIAL CONSTRUCTION INTELLIGENCE
                </p>
            </div>
        </div>
    </footer>
);

export default Footer;
